<script>
export default {
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    uppercase: {
      type: Boolean,
      default: false,
    },
    inputLabel: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
    prependIcon: {
      type: String,
      default: '',
    },
    appendIcon: {
      type: String,
      default: '',
    },
  },
}
</script>
